import ErrorFallback from 'components/error-fallback/ErrorFallback';
import { Column, ColumnProps } from 'primereact/column';
import { DataTableValueArray } from 'primereact/datatable';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { DataTableStyled } from '../StyledGrid';

interface ColumnPropsExtended extends ColumnProps {
  isDataReadonly?: boolean;
  isTitleReadonly?: boolean;
  placeholder?: string;
}

type TProps = {
  value?: DataTableValueArray | undefined;
  columns?: ColumnPropsExtended[] | undefined;
  notes?: { note: React.ReactNode | string; description: React.ReactNode | string }[] | undefined;
  className?: string;
};

const DynamicGridPdf = ({ value, columns, className }: TProps) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DataTableStyled
        className={className}
        value={value}
        dataKey="id"
        tableStyle={{ minWidth: '49rem', maxWidth: '80rem' }}
        style={{ overflow: 'auto', display: 'grid' }}
        showGridlines
        editMode="cell"
      >
        {columns?.map((x) => (
          <Column
            style={{ wordBreak: 'normal', overflowWrap: 'break-word' }}
            key={x.field}
            {...x}
            headerStyle={{ wordBreak: 'normal', overflowWrap: 'break-word', ...x.headerStyle }}
          />
        ))}
      </DataTableStyled>
    </ErrorBoundary>
  );
};

export default DynamicGridPdf;
